import cn from 'classnames'
import { OfferingSwitcher } from 'legacy/lut/components/widgets/public/partner360/offeringsSwithList/OfferingSwitcher'
import { FC } from 'react'

import { LoaderOverlay } from 'cng-common/components/loaderOverlay'

import { useFormOfferings } from './hooks/useFormOfferings'
import { useOfferingsForRtm } from './hooks/useOfferingsForRtm'

import styles from './Offerings.module.scss'

interface IOfferingsProps {
  isDisabled?: boolean
}

export const Offerings: FC<IOfferingsProps> = ({ isDisabled }) => {
  const { wip, offeringsForCurrentRtm } = useOfferingsForRtm()
  const { offerings, onChangeOfferings, isModified } = useFormOfferings(offeringsForCurrentRtm)

  return (
    <div>
      <LoaderOverlay isVisible={wip} />
      <div
        className={cn(styles.list, {
          [styles.isChanged]: isModified,
        })}
      >
        {offerings.map((offering, index) => (
          <OfferingSwitcher
            isTooltipDisabled
            isToggleDisabled={isDisabled}
            key={index}
            offering={offering}
            index={index}
            availableProgramTypes={offerings}
            onToggle={onChangeOfferings}
          />
        ))}
      </div>
    </div>
  )
}
